export enum RiskProgramType {
  RETROSPECTIVE_CHART_REVIEW = "0",
  MA_RADV = "1",
  VENDOR_QA_MRVA = "2",
}
